import { useContext, useMemo } from 'react'

import { FilterCollection } from '@hap/analytics'

import { DatastoreContext } from './context'

export const useDatastore = (collection: Nullable<FilterCollection>) => {
  const context = useContext(DatastoreContext)
  return {
    data: collection
      ? context.data[collection as unknown as keyof typeof context.data] || []
      : [],
    isLoading: context.isLoading,
    isInitialLoading: context.isInitialLoading,
  }
}

export const useOrganizationDatastore = () => {
  const context = useContext(DatastoreContext)
  return {
    data: (context.data.organization as unknown as { maxDate: string }) || {},
    isLoading: context.isLoading,
    isInitialLoading: context.isInitialLoading,
  }
}

export const useDatastoreCollections = () => {
  const context = useContext(DatastoreContext)
  return { data: context.data }
}

export const useUserById = (userId: string | null | undefined) => {
  const { data, isLoading } = useDatastore(FilterCollection.Users)
  const record = useMemo(() => {
    if (!userId) return undefined
    const user = data.find((u) => u.id === userId)
    if (!user) return undefined
    return {
      id: user.id,
      email: user.meta.email,
      firstName: user.meta.firstName,
      lastName: user.meta.lastName,
      avatarFileId: user.meta?.avatarFileId,
    }
  }, [data, userId])
  return { record, isLoading }
}

export const useTagById = (tagId: string | null | undefined) => {
  const { data, isLoading } = useDatastore(FilterCollection.Tags)
  const record = useMemo(() => {
    if (!tagId) return undefined
    const tag = data.find((u) => u.id === tagId)
    if (!tag) return undefined
    return {
      id: tag.id,
      name: tag.name,
      color: tag.meta.color,
    }
  }, [data, tagId])
  return { record, isLoading }
}
